import produce from 'immer';

import {
    WALLET_LINKING_SET_RETAIL_CARD_NUMBER,
    WALLET_LINKING_SET_OPEN_URL,
    WALLET_LINKING_SET_DOCUMENT_DATA,
    WALLET_LINKING_SET_PLAYER_DATA,
    WALLET_LINKING_SET_PIN
} from './actions';

export const defaultState = {};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case WALLET_LINKING_SET_RETAIL_CARD_NUMBER:
        case WALLET_LINKING_SET_RETAIL_CARD_NUMBER + reducerSuffix: {
            draftState.retailCardNumber = action.payload;

            break;
        }

        case WALLET_LINKING_SET_OPEN_URL:
        case WALLET_LINKING_SET_OPEN_URL + reducerSuffix: {
            draftState.openUrl = action.payload;

            break;
        }

        case WALLET_LINKING_SET_PIN:
        case WALLET_LINKING_SET_PIN + reducerSuffix: {
            draftState.pin = action.payload;

            break;
        }

        case WALLET_LINKING_SET_DOCUMENT_DATA:
        case WALLET_LINKING_SET_DOCUMENT_DATA + reducerSuffix: {
            draftState.documentData = action.payload;

            break;
        }

        case WALLET_LINKING_SET_PLAYER_DATA:
        case WALLET_LINKING_SET_PLAYER_DATA + reducerSuffix: {
            draftState.playerData = action.payload;

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
